module.exports = __webpack_public_path__ + "static/img/优秀毕业生-06.d91a4ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue12/05/优秀毕业生-06.jpg
// module id = fyQu
// module chunks = 7